import { SESSION_QUESTION_TARGET, SESSION_SECONDS } from '../data/topics';
import { SYLLABUS_YEAR } from '../data/syllabus';

/** Conservative minimum of original items shipped across the named L1 forms. */
export const QUESTION_BANK_SIZE = 720;

export const SESSION_DURATION_MINUTES = Math.round(SESSION_SECONDS / 60);

/** Human-readable session length with minutes for exam-day clarity. */
export const SESSION_DURATION_LABEL = `2 hours 15 minutes (${SESSION_DURATION_MINUTES} min)`;

export const QUESTION_BANK_LABEL = `${QUESTION_BANK_SIZE}+`;

export const QUESTION_BANK_SHORT = `${QUESTION_BANK_LABEL} original Level 1 practice items`;

export const QUESTION_BANK_FULL = `${QUESTION_BANK_LABEL} original Level 1 practice items across all 10 topics (${SYLLABUS_YEAR} weights)`;

export const SESSION_MOCK_SHORT = `${SESSION_QUESTION_TARGET} questions · ${SESSION_DURATION_MINUTES} minutes`;

export const SESSION_MOCK_DESCRIPTION = `${SESSION_QUESTION_TARGET}-question timed session · ${SESSION_DURATION_MINUTES} minutes · official ${SYLLABUS_YEAR} topic weights`;

export const SESSION_MOCKS_LINE =
  'Eight named timed mocks at official weights — one complimentary Mock 1 to start';

export const EXAM_DAY_CLARITY =
  'The real Level 1 exam is 180 items in two 135-minute sessions. Each of our mocks covers one full session block.';

/** Rough count of non-overlapping full sessions the bank can support at current size. */
export const DISTINCT_SESSIONS_ESTIMATE = Math.floor(QUESTION_BANK_SIZE / SESSION_QUESTION_TARGET);

export const PAID_PASS_BANK_LINE = `Eight weighted timed mocks, analysis, and topic drills from a ${QUESTION_BANK_LABEL} item bank`;

export { SESSION_QUESTION_TARGET };
